var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import Loader from '@cta-portal/webapp-common/src/components/loader';
import { useContext } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { ChangelogTab, RoutePath, generateRoutePath } from '../../app/router/config';
import Header from '../../components/changelog/header';
import Item from '../../components/changelog/item';
import Menu from '../../components/changelog/menu';
import MobileToolbar from '../../components/changelog/mobile-toolbar';
import Toolbar from '../../components/changelog/toolbar';
import { SettingsContext } from '../../context/settings';
import { useChangelog } from '../../hooks/changelog/use-changelog';
import Layout from '../../layout';
export default function Changelog() {
    var t = useI18n().t;
    var tab = useParams().tab;
    var navigate = useNavigate();
    var showChangelogMenu = useContext(SettingsContext).showChangelogMenu;
    var _a = useChangelog(tab), items = _a.items, selectedItemTitle = _a.selectedItemTitle, setSelectedItemTitle = _a.setSelectedItemTitle, searchQuery = _a.searchQuery;
    if (!tab || !Object.values(ChangelogTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.CHANGELOG, { tab: ChangelogTab.TCG }));
        return _jsx(_Fragment, {});
    }
    var tabs = [
        {
            label: t('changelog.tabs.tcg'),
            path: generateRoutePath(RoutePath.CHANGELOG, { tab: ChangelogTab.TCG }),
            selected: tab === ChangelogTab.TCG,
        },
        {
            label: t('changelog.tabs.arise'),
            path: generateRoutePath(RoutePath.CHANGELOG, { tab: ChangelogTab.ARISE }),
            selected: tab === ChangelogTab.ARISE,
            disabled: true,
        },
    ];
    return (_jsx(Layout, { fullWidth: true, children: _jsxs(_Fragment, { children: [items.length === 0 && _jsx(Loader, { black: true }), _jsx(Header, {}), _jsx(Menu, { items: items, selectedItemTitle: selectedItemTitle, setSelectedItemTitle: setSelectedItemTitle }), _jsx(Toolbar, { tabs: tabs }), _jsx(MobileToolbar, { searchQuery: searchQuery }), _jsx(Container, { showChangelogMenu: showChangelogMenu, children: items.map(function (item, index) {
                        var _a;
                        return (_jsx(Item, { data: item, tabLabel: ((_a = tabs.find(function (tab) { return tab.selected; })) === null || _a === void 0 ? void 0 : _a.label) || '' }, index));
                    }) })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 256px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 256px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n"])), function (_a) {
    var showChangelogMenu = _a.showChangelogMenu;
    return (showChangelogMenu ? '40px 32px 40px 312px' : '40px 32px');
});
var templateObject_1;
